export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8916.fb778e52.jpg";